
/**
 * Remove o prefixo do gerador do nome do estabelecimento
 * @param establishmentName - Nome do estabelecimento que pode conter o prefixo
 * @param isDemoMode - Se true, retorna "ESTABELECIMENTO" ao invés do nome real
 * @returns Nome do estabelecimento sem o prefixo ou "ESTABELECIMENTO" se isDemoMode ativo
 */
export const removeGeneratorPrefix = (
  establishmentName: string | null | undefined,
  isDemoMode?: boolean
): string => {
  if (isDemoMode) return 'ESTABELECIMENTO';
  if (!establishmentName) return 'N/A';
  return establishmentName.replace(/^ZAMP I\s+/, '').trim();
};
